import React from 'react';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';
import { useLocation } from 'react-router';


const HeaderInfoWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  
  const paramLang = queryParams.get('lang');
  
  const {
    widgetParams,
    defaultPaddings,
  } = props;



  return (
    <div
      style={defaultPaddings}
      className={styles.headerInfo}
    >
      <img src="https://picsum.photos/200"/>
      {
        paramLang === 'en' ?
        <p>Lorem ipsum dolor sit amet, consectetur</p> :
        <p> بل إن له جذور في الأدب اللاتيني الكلاسيكي منذ</p>
      }
    </div>
  );
};

export default HeaderInfoWidget;
